var map = {
	"./background.jpg": 55,
	"./background@2x.jpg": 56
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img ^\.\/background.*\.jpg$
// module id = 112
// module chunks = d-game